import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Col from 'component/utils/Col'
import Form from 'component/utils/Form'
import Field from 'component/utils/Field'
import Input from 'component/utils/Input'
import DatePicker from 'component/utils/DatePicker'
import RegionCompanySelect from 'component/branch/RegionCompanySelect'
import Notification from 'component/utils/Notification'

class PeriodPickerOccurrencesCode8 extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    fetchCode8Occurrences: PropTypes.func.isRequired,
    setValueToField: PropTypes.func.isRequired,
    values: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    fields: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      dtStart: null,
      dtEnd: null,
      selectedBranches: [],
      allBranches: false,
      branchValidation: false,
    }

    this.handleChangeStartDate = this.handleChangeStartDate.bind(this)
    this.handleChangeEndDate = this.handleChangeEndDate.bind(this)
    this.handleFetchCode8Occurences = this.handleFetchCode8Occurences.bind(this)
  }

  handleChangeStartDate(event) {
    const { setValueToField } = this.props

    this.setState({ dtStart: event })

    const dateFormated = event.format('DD/MM/YYYY')

    setValueToField('dtStart', dateFormated)
  }

  handleChangeEndDate(event) {
    const { setValueToField } = this.props

    this.setState({ dtEnd: event })

    const dateFormated = event.format('DD/MM/YYYY')

    setValueToField('dtEnd', dateFormated)
  }

  handleFetchCode8Occurences(event) {
    event.preventDefault()

    const {
      fetchCode8Occurrences,
      values,
      auth: { user },
    } = this.props

    const { selectedBranches, allBranches } = this.state

    const idBranches = selectedBranches
      .filter((item) => item.isBranch !== undefined)
      .map((item) => item.value)
    const idRegions = selectedBranches
      .filter((item) => item.isBranch === undefined)
      .map((item) => item.value)

    if (
      !allBranches &&
      !idBranches.length &&
      !idRegions.length &&
      user.locationCode === '999'
    ) {
      this.setState({ branchValidation: true })
    } else {
      this.setState({ branchValidation: false })

      const data = {
        ...values,
        idBranches,
        idRegions,
        allBranches,
      }

      fetchCode8Occurrences(data)
    }
  }

  handleAllChange = (event) => {
    const { checked } = event.target
    if (checked) {
      this.setState({
        allBranches: checked,
        selectedBranches: [],
        branchValidation: false,
      })
    } else {
      this.setState({ allBranches: checked })
    }
  }

  handleChangeBranch = (values, allOptions) => {
    const allValues = []

    allOptions.map((newItem) => {
      newItem.visible = true
      newItem.disabled = false
    })

    /* istanbul ignore else */
    if (!!values && values.length > 0) {
      const regionsSelected = values.filter(
        (item) => item.isBranch === undefined
      )

      values.map((item) => {
        if (!item.isBranch) {
          allOptions
            .filter((branchItem) => branchItem.idRegion === item.value)
            .map((newItem) => {
              newItem.visible = false
              newItem.disabled = true
            })
          allValues.push(item)
        } else {
          /* istanbul ignore else */
          if (
            regionsSelected.filter(
              (regionItem) => regionItem.value === item.idRegion
            ).length === 0
          ) {
            allValues.push(item)
          }
        }
      })
    }
    this.setState({ selectedBranches: allValues, branchValidation: false })
  }

  renderErrorValidation = (message) => (
    <div className='margin-top'>
      <Notification className='notification-warning' message={message} />
    </div>
  )

  render() {
    const {
      translate,
      fields,
      auth: { user },
    } = this.props

    const { allBranches, branchValidation } = this.state

    return (
      <form
        onSubmit={this.handleFetchCode8Occurences}
        className='code8-ocurrences-page container-mobile'
      >
        <div className='margin-left-double margin-right-double center-select-date'>
          <Col xs={12} className='margin-bottom-double padding-bottom-double'>
            <Col xs={12} className='margin-bottom-small'>
              <h3 className='name color-text'>
                {translate('mobile.olderOccurrences-code8')}
              </h3>
            </Col>

            <Col xs={12}>
              <span className='gray-label'>
                {translate('occurrences-code8.hint')}
              </span>
            </Col>

            {user && user.locationCode === '999' && (
              <Col xs={12}>
                {branchValidation &&
                  this.renderErrorValidation(
                    translate('companySelect.mandatory')
                  )}

                <Field
                  {...fields.allBranches}
                  error={translate(fields.allBranches.error)}
                  input={{ value: this.state.allBranches }}
                >
                  <Input
                    id='allBranches'
                    type='checkbox'
                    onChange={this.handleAllChange}
                    label={translate('ruptures.allBranches')}
                  />
                </Field>

                <Field
                  {...fields.idBranch}
                  error={translate(fields.idBranch.error)}
                  hint={translate('occurrences-code8.idBranch')}
                  input={{ value: this.state.selectedBranches }}
                  icon='glyph glyph-clock'
                >
                  <RegionCompanySelect
                    {...fields.idBranch.input}
                    onChange={this.handleChangeBranch}
                    selectedBranches={this.state.selectedBranches}
                    disabled={allBranches}
                  />
                </Field>
              </Col>
            )}

            <Col xs={12} sm={6} md={4}>
              <Field
                {...fields.dtStart}
                error={translate(fields.dtStart.error)}
                glyph='glyph glyph-calendar'
                validate
              >
                <DatePicker
                  date={this.state.dtStart}
                  onDateChange={this.handleChangeStartDate}
                  placeholder={translate('occurrences-code8.from')}
                  isOutsideRange
                />
              </Field>
            </Col>

            <Col xs={12} sm={6} md={4}>
              <Field
                {...fields.dtEnd}
                error={translate(fields.dtEnd.error)}
                glyph='glyph glyph-calendar'
                validate
              >
                <DatePicker
                  date={this.state.dtEnd}
                  onDateChange={this.handleChangeEndDate}
                  placeholder={translate('occurrences-code8.to')}
                  isOutsideRange
                />
              </Field>
            </Col>

            <Col xs={12} sm={6} md={3} className='margin-top-one-point-seven'>
              <button
                type='submit'
                className='button button-primary button-full'
              >
                {translate('occurrences-code8.filter')}
              </button>
            </Col>
          </Col>
        </div>
      </form>
    )
  }
}

const fields = ['allBranches', 'idBranch', 'dtStart', 'dtEnd']

export default Form({ fields })(PeriodPickerOccurrencesCode8)

export { PeriodPickerOccurrencesCode8 }
